import styled, { css } from "styled-components";

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;
  text-transform: uppercase;
  color: #3a3c3b;
  position: absolute;
  font-weight: 600;
  z-index: 40;

  user-select: none;
  /* transition: all 0.2s ease-in-out; */

  ${({ size, hasLogo, top, left }) => css`
    width: ${hasLogo ? "auto" : `${size.width}px`};
    height: ${hasLogo ? "auto" : `${size.height}px`};
    ${size.css}
    top: ${`${top}px`};
    left: ${`${left}px`};

    background-color: ${hasLogo ? "transparent" : `#e0dfe2`};

    & > img {
      /* width: 200%; */
      max-height: ${`${size.height}px`};
      object-fit: contain;
    }
  `}
`;

export const DraggableLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;
  text-transform: uppercase;
  color: #3a3c3b;
  font-weight: 600;
  z-index: 40;
  /* background-color: #e0dfe2; */
  position: absolute;
  /* transition: all 0.2s ease-in-out; */

  cursor: move;

  & > span {
    pointer-events: none;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }

  ${({ size }) => css`
    width: ${`${size.width}px`};
    height: ${`${size.height}px`};
    ${size.css}

    & > img {
      /* width: 200%; */
      max-height: ${`${size.height}px`};
      object-fit: contain;
    }
  `}
`;
